import Video from '@/components/Video';
import { OddsVariant } from '@/config/odds/OddsVariant';
import { fetchWinningNumbers } from '@/helpers/fetchWinningNumbers';
import { getGameByShortname } from '@/helpers/getGameByShortname';
import { printVideoDescription } from '@/utilities/formDrawVideoDescription';
import { useEffect, useState } from 'react';

const defaultText = `Die Live-Ziehung der Gewinnzahlen von LOTTO 6aus49 im LOTTO-Studio in Saarbrücken startet pünktlich jeden Mittwoch um 18:25 Uhr und jeden Samstag um 19:25 Uhr nach einem kurzen Countdown. Nach der Begrüßung der Zuschauerinnen durch die Moderatorin der Ziehungssendung - Miriam Hannah, Celina Fries, Sophia Schreiber, Aliena Pfeiffer oder Louisa Schlang - beginnt sich die Ziehungstrommel mit den Lottokugeln von 1 bis 49 zu drehen. Nach der Ziehung der sechs Lottozahlen startet im Anschluss die Ziehung der Superzahl in einer separaten Ziehungstrommel. Abschließend werden nochmal alle Gewinnzahlen von LOTTO 6aus49 sowie die Superzahl präsentiert und die Gewinnzahlen der Zusatzlotterien Spiel 77 und SUPER 6 bekannt gegeben.`;

export default function LiveDraw() {
  const [video, setVideo] = useState<{
    date: Date;
    url: string;
  }>();

  const [videoDescription, setVideoDescription] = useState<string>(defaultText);

  useEffect(() => {
    async function fetchData() {
      const gameConfig = getGameByShortname('lotto6aus49');
      setVideo(await (await fetch(`/api/data/livedraw`)).json());
      let winningNumbers: any = await fetchWinningNumbers(
        OddsVariant.Lotto6aus49,
        gameConfig
      );
      winningNumbers = Array.isArray(winningNumbers)
        ? winningNumbers[0]
        : winningNumbers;
      if (winningNumbers?.drawDate) {
        setVideoDescription(
          printVideoDescription(defaultText, winningNumbers, 'lotto')
        );
      }
    }
    fetchData();
  }, []);

  return video ? (
    <Video
      url={video.url}
      title={`Live-Ziehung vom ${video.date}`}
      volltextVersion={videoDescription}
      boxed
    />
  ) : null;
}
